import { WebParameterContext, WebResponesContext } from '../../model/common';
export class ServicesPotentialCustmoer{
  constructor(
  ) {

  }
  public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
    webcontext.RequestBody={};
    webcontext.RequestBody.Type=3;//唤醒  
    return webcontext;
  }

}